<template>
  <div class="options">
    <el-button type="primary" icon="el-icon-plus" @click="showDialog = true" v-if="$root.isSystem">New station</el-button>
    <el-dialog :append-to-body="true" v-if="$auth.user.isSystem" :top="$screen.mobile ? '0vh' : '15vh'" :visible.sync="showDialog" :show-close="false" width="800px" custom-class="dialog-no-padding dialog-invert full-width-mobile">
      <upsert-form
        @created="created"
        v-if="showDialog" />
    </el-dialog>
  </div>
</template>

<script>
import UpsertForm from '@/components/dashboard/stations/UpsertForm'
import Search from './../SearchInput'

export default {
  name: 'PricingOptions',
  components: { UpsertForm, Search },
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showDialog: false
    }
  },
  methods: {
    created (station) {
      this.$emit('created', station)
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .options {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    @include breakpoint (xs) {
      width: 100%;
      flex-direction: column;

      button {
        height: 60px;
        width: 100%;
      }
    } 
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Stations/Options.vue